// extracted by mini-css-extract-plugin
module.exports = {"wrap":"fundFlows_wrap__3wfv1","filters":"fundFlows_filters__3iNJI","row":"fundFlows_row__3GTd3","submitBtns":"fundFlows_submitBtns__3bG6K","table":"fundFlows_table__2bHv5"};